module.exports = __webpack_public_path__ + "static/media/seesaw.ac1122f4.svg";